<div class="main_content">
    <div #page_section class="page_main_sec">
      <div class="OpenSearch_main_sec">
        <!-- title bar section Start-->
        <div class="container-fluid">
  
        </div>
        <!-- title bar section  End-->
      </div>
  <div class="tab-content">
  <!-- <div class="contentsection  col-lg-12"
  style="margin-right: 0px; margin-left: 0px; margin-top: 60px; overflow:scroll !important; height: 100% !important;"> -->
  <div>
  <div class="row">
    <div class="col-lg-1" ></div>
    <div  [style.display]="is_dataloaded ? 'block' : 'none'"   class="col-lg-5  border table_card_sec" id='Chartdiv1'> </div>
    <div  [style.display]="is_dataloaded ? 'block' : 'none'" class="col-lg-5  border table_card_sec" id='Chartdiv2'></div>
    <div class="col-lg-1" ></div>
  </div>
  <div class="row">
    <div class="col-lg-1" ></div>
    <div  [style.display]="is_dataloaded ? 'block' : 'none'" class="col-lg-5  border table_card_sec" id='Chartdiv3'> </div>
    <div *ngIf="!IsContractView"  [style.display]="is_dataloaded ? 'block' : 'none'" class="col-lg-5  border table_card_sec" id='Chartdiv4'></div>
    <div *ngIf="IsContractView"   [style.display]="is_dataloaded ? 'block' : 'none'" class="col-lg-5  border table_card_sec" id='Chartdiv5'> </div>
    <div class="col-lg-1" ></div>
  </div>
  <div class="row">
    <div class="col-lg-1" ></div>
    <div  *ngIf="!IsContractView"  [style.display]="is_dataloaded ? 'block' : 'none'" class="col-lg-5  border table_card_sec" id='Chartdiv5'> </div>
    <div *ngIf="!IsContractView"  [style.display]="is_dataloaded ? 'block' : 'none'" class="col-lg-5  border table_card_sec" id='Chartdiv6'></div>
    <div class="col-lg-1" ></div>
  </div>
  </div>
  
  <!-- <div class="row" >
    <div class="col-lg-6 border Chart"  id='Chartdiv3'> </div>
    <div class="col-lg-6 border Chart" id='Chartdiv4'></div>
  </div>
  
  <div class="row" >
    <div class="col-lg-6 border Chart"  id='Chartdiv5'> </div>
    <div class="col-lg-6 border Chart" id='Chartdiv6'></div>
  </div> -->
  </div>
  </div>
  </div>
  <div>
  
  